var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategoryLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.43641 5.97414C6.43175 5.76927 6.35333 5.57347 6.21633 5.42463L1.38709 0.252696C1.2385 0.0948627 1.03511 0.00403859 0.821488 0.000131215C0.607871 -0.00377616 0.401467 0.0795519 0.247507 0.231851C0.0935478 0.38415 0.00458858 0.592995 0.000148739 0.812608C-0.00429158 1.03222 0.0761456 1.24469 0.223816 1.40343L4.51856 6L0.223816 10.5966C0.0761452 10.7553 -0.004292 10.9678 0.000148298 11.1874C0.00458812 11.407 0.0935473 11.6158 0.247507 11.7681C0.401466 11.9204 0.607871 12.0038 0.821488 11.9999C1.03511 11.996 1.2385 11.9051 1.38709 11.7473L6.21633 6.57537C6.29014 6.49529 6.34764 6.40085 6.38543 6.2976C6.42323 6.19435 6.44055 6.08438 6.43641 5.97414Z",
    fill: "#0081DF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryLinkIcon);
export default __webpack_public_path__ + "static/media/categoryLinkIcon.80a0c8f43a32dd7b10d561a74d0eb023.svg";
export { ForwardRef as ReactComponent };